import { MutationHookOptions, useMutation } from "@apollo/client";

import { CreateWithdrawalMutation, CreateWithdrawalMutationVariables } from "@ctypes";
import { CREATE_WITHDRAWAL } from "@graphql";
import { useAccount } from "@hooks/account";
import { useUser } from "@hooks/user";

const REFETCH_DELAY = 10000; // 10 seconds

export const useCreateWithdrawal = (
  options?: MutationHookOptions<CreateWithdrawalMutation, CreateWithdrawalMutationVariables>,
) => {
  const { refetch: refetchAccount } = useAccount();
  const { refetch: refetchUser } = useUser();

  /**
   * There is a delay in retrieving the new balance from the back-end. This adds
   * a small timeout for the refetch to address that issue.
   */
  const refetch = () => {
    setTimeout(() => {
      refetchUser();
      refetchAccount();
    }, REFETCH_DELAY);
  };

  return useMutation<CreateWithdrawalMutation, CreateWithdrawalMutationVariables>(
    CREATE_WITHDRAWAL,
    {
      ...options,
      onCompleted: (data) => {
        refetch();
        options?.onCompleted?.(data);
      },
    },
  );
};
